import { NgModule } from '@angular/core';
import { NotesModule } from 'app/components/notes/notes.module';
import { SharedModule } from 'app/shared/shared.module';
import { CustomerSummaryPreviewComponent } from './customer-summary-preview.component';

@NgModule({
  declarations: [
    CustomerSummaryPreviewComponent
  ],
  imports: [
    SharedModule,
    NotesModule
  ],
  exports:[
    CustomerSummaryPreviewComponent
  ]
})
export class CustomerSummaryPreviewModule { }
